import { useFormStore } from '@/stores/form-store';

interface FormOption {
  value: string;
  label: string;
}

function isStringOptionValue(value: string | null | undefined): value is string {
  return Object.prototype.toString.call(value) === '[object String]';
}

export function useCamundaOptions(name: string): FormOption[] {
  const { variables } = useFormStore();

  const value = variables?.[name];
  const label = variables?.[`${name}_label`];

  if (isStringOptionValue(value) && isStringOptionValue(label) && value && label) {
    return [{ value, label }];
  }

  if (isStringOptionValue(value) && value) {
    return [{ value, label: value }];
  }

  return [];
}
